export const ONBOARDING_NEXT_PAGE = 'ONBOARDING_NEXT_PAGE';
export const ONBOARDING_SKIP = 'ONBOARDING_SKIP';
export const ONBOARDING_RESET = 'ONBOARDING_RESET';
export const ONBOARDING_SWIPE_DEMO_SHOWN = 'ONBOARDING_SWIPE_DEMO_SHOWN';

export enum Pages {
  LOCATION_SCREEN = 'LOCATION_SCREEN',
  NOTIFICATIONS_SCREEN = 'NOTIFICATIONS_SCREEN',
}
